var map = {
	"./icon-topic-1.svg": 2499,
	"./icon-topic-10.svg": 6399,
	"./icon-topic-2.svg": 1596,
	"./icon-topic-3.svg": 8698,
	"./icon-topic-4.svg": 719,
	"./icon-topic-5.svg": 5535,
	"./icon-topic-6.svg": 3668,
	"./icon-topic-7.svg": 2322,
	"./icon-topic-8.svg": 2179,
	"./icon-topic-9.svg": 9552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4090;